// QSR (Quick Service Restaurant) Configuration for The Daily Grill Demo
// Multi-location management with SPLH, Drive-Through, and POS metrics

export const QSR_DEMO_LOCATIONS = [
  {
    id: 'tdg-penrith',
    name: 'The Daily Grill Penrith',
    shortName: 'Penrith',
    address: '14 Riley Street',
    suburb: 'Penrith',
    state: 'NSW',
    postcode: '2750',
    phone: '(02) 4722 3100',
    type: 'drive_through',
    region: 'NSW',
    manager: 'Sarah Mitchell',
    openingHours: '6:00 AM - 11:00 PM',
    features: ['Drive-Through', 'Dine-In', 'Takeaway', 'Delivery'],
    integrations: ['summit_qsr', 'square'],
    metrics: {
      splh: 68.50,
      splhTarget: 65,
      dailyRevenue: 12500,
      weeklyRevenue: 87500,
      monthlyRevenue: 375000,
      avgTransactionValue: 18.50,
      transactionsPerDay: 675,
      labourCostPercent: 24.5,
      foodCostPercent: 31.2,
      driveThrough: {
        avgWaitTime: 3.2,
        targetWaitTime: 3.5,
        throughputPerHour: 85,
        peakThroughput: 120,
        accuracy: 98.5,
        carsServedDaily: 420
      },
      staff: {
        onShift: 12,
        scheduled: 14,
        labourHours: 168
      }
    },
    performance: {
      rank: 2,
      trend: 'up',
      changePercent: 8.5,
      rating: 4.6
    }
  },
  {
    id: 'tdg-footscray',
    name: 'The Daily Grill Footscray',
    shortName: 'Footscray',
    address: '108 Barkly Street',
    suburb: 'Footscray',
    state: 'VIC',
    postcode: '3011',
    phone: '(03) 9689 4200',
    type: 'dine_in',
    region: 'VIC',
    manager: 'Michael Chen',
    openingHours: '7:00 AM - 10:00 PM',
    features: ['Dine-In', 'Takeaway', 'Delivery'],
    integrations: ['square'],
    metrics: {
      splh: 52.30,
      splhTarget: 55,
      dailyRevenue: 8200,
      weeklyRevenue: 57400,
      monthlyRevenue: 246000,
      avgTransactionValue: 22.80,
      transactionsPerDay: 360,
      labourCostPercent: 26.8,
      foodCostPercent: 32.5,
      driveThrough: {
        avgWaitTime: 3.6,
        targetWaitTime: 3.5,
        throughputPerHour: 78,
        peakThroughput: 108,
        accuracy: 96.8,
        carsServedDaily: 300
      },
      staff: {
        onShift: 8,
        scheduled: 10,
        labourHours: 112
      }
    },
    performance: {
      rank: 4,
      trend: 'stable',
      changePercent: 1.2,
      rating: 4.3
    }
  },
  {
    id: 'tdg-southport',
    name: 'The Daily Grill Southport',
    shortName: 'Southport',
    address: '62 Nerang Street',
    suburb: 'Southport',
    state: 'QLD',
    postcode: '4215',
    phone: '(07) 5591 7800',
    type: 'drive_through',
    region: 'QLD',
    manager: 'Emma Thompson',
    openingHours: '6:00 AM - 11:00 PM',
    features: ['Drive-Through', 'Dine-In', 'Takeaway', 'Delivery'],
    integrations: ['summit_qsr', 'square'],
    metrics: {
      splh: 71.20,
      splhTarget: 65,
      dailyRevenue: 14200,
      weeklyRevenue: 99400,
      monthlyRevenue: 426000,
      avgTransactionValue: 17.90,
      transactionsPerDay: 795,
      labourCostPercent: 23.1,
      foodCostPercent: 30.8,
      driveThrough: {
        avgWaitTime: 2.8,
        targetWaitTime: 3.5,
        throughputPerHour: 95,
        peakThroughput: 135,
        accuracy: 99.1,
        carsServedDaily: 510
      },
      staff: {
        onShift: 14,
        scheduled: 15,
        labourHours: 182
      }
    },
    performance: {
      rank: 1,
      trend: 'up',
      changePercent: 12.3,
      rating: 4.8
    }
  },
  {
    id: 'tdg-joondalup',
    name: 'The Daily Grill Joondalup',
    shortName: 'Joondalup',
    address: '24 Grand Boulevard',
    suburb: 'Joondalup',
    state: 'WA',
    postcode: '6027',
    phone: '(08) 9301 5500',
    type: 'dine_in',
    region: 'WA',
    manager: 'David Wilson',
    openingHours: '7:00 AM - 10:00 PM',
    features: ['Dine-In', 'Takeaway', 'Delivery'],
    integrations: ['square'],
    metrics: {
      splh: 58.90,
      splhTarget: 55,
      dailyRevenue: 9800,
      weeklyRevenue: 68600,
      monthlyRevenue: 294000,
      avgTransactionValue: 21.50,
      transactionsPerDay: 456,
      labourCostPercent: 25.2,
      foodCostPercent: 31.5,
      driveThrough: {
        avgWaitTime: 3.4,
        targetWaitTime: 3.5,
        throughputPerHour: 82,
        peakThroughput: 110,
        accuracy: 95.4,
        carsServedDaily: 340
      },
      staff: {
        onShift: 9,
        scheduled: 11,
        labourHours: 128
      }
    },
    performance: {
      rank: 3,
      trend: 'up',
      changePercent: 6.8,
      rating: 4.5
    }
  },
  {
    id: 'tdg-prospect',
    name: 'The Daily Grill Prospect',
    shortName: 'Prospect',
    address: '179 Prospect Road',
    suburb: 'Prospect',
    state: 'SA',
    postcode: '5082',
    phone: '(08) 8269 3300',
    type: 'dine_in',
    region: 'SA',
    manager: 'Lauren Hayes',
    openingHours: '7:00 AM - 10:00 PM',
    features: ['Dine-In', 'Takeaway', 'Delivery'],
    integrations: ['square'],
    metrics: {
      splh: 55.40,
      splhTarget: 55,
      dailyRevenue: 7600,
      weeklyRevenue: 53200,
      monthlyRevenue: 228000,
      avgTransactionValue: 20.30,
      transactionsPerDay: 374,
      labourCostPercent: 27.1,
      foodCostPercent: 33.0,
      driveThrough: {
        avgWaitTime: 4.1,
        targetWaitTime: 3.5,
        throughputPerHour: 72,
        peakThroughput: 102,
        accuracy: 93.1,
        carsServedDaily: 280
      },
      staff: {
        onShift: 7,
        scheduled: 9,
        labourHours: 98
      }
    },
    performance: {
      rank: 5,
      trend: 'stable',
      changePercent: 2.4,
      rating: 4.2
    }
  }
];

// QSR Staff Hierarchy & Permissions (from Excel mapping)
export const QSR_STAFF_HIERARCHY = {
  director: {
    title: 'Director',
    level: 1,
    locationAccess: 'all',
    permissions: ['all'],
    dashboardFocus: ['Multi-Location P&L', 'Strategic KPIs', 'Expansion Planning', 'Franchise Compliance'],
    description: 'Full access to all 5 locations and enterprise-level reporting'
  },
  area_manager: {
    title: 'Area Manager',
    level: 2,
    locationAccess: 'all',
    permissions: ['view_operations', 'view_management', 'view_financials', 'manage_staff', 'view_inventory', 'edit_roster', 'view_compliance'],
    dashboardFocus: ['Cross-Location SPLH', 'Labour Cost Comparison', 'Drive-Through Performance', 'Staff Scheduling'],
    description: 'Oversees all locations with operational and financial visibility'
  },
  store_manager: {
    title: 'Store Manager',
    level: 3,
    locationAccess: 'single',
    permissions: ['view_operations', 'view_management', 'manage_staff', 'view_inventory', 'edit_roster', 'view_daily_sales'],
    dashboardFocus: ['Store SPLH', 'Shift Performance', 'Food Cost Control', 'Staff Rostering'],
    description: 'Single location management with full operational control'
  },
  shift_supervisor: {
    title: 'Shift Supervisor',
    level: 4,
    locationAccess: 'single',
    permissions: ['view_operations', 'view_daily_sales', 'manage_shift_staff', 'view_inventory_levels'],
    dashboardFocus: ['Current Shift KPIs', 'Order Queue', 'Staff Attendance', 'Temp & Safety Checks'],
    description: 'Shift-level operational oversight at assigned location'
  }
};

export const QSR_BENCHMARKS = {
  splh: {
    excellent: 70,
    good: 60,
    average: 50,
    poor: 40,
    industryAvg: 55,
    source: 'Restaurant & Catering Industry Association (R&CA) Australia 2025'
  },
  driveThrough: {
    waitTime: {
      excellent: 2.5,
      good: 3.5,
      average: 4.5,
      poor: 6.0,
      industryAvg: 3.8
    },
    accuracy: {
      excellent: 99,
      good: 97,
      average: 95,
      poor: 90
    },
    throughput: {
      excellent: 100,
      good: 80,
      average: 60,
      poor: 40
    }
  },
  labourCost: {
    excellent: 22,
    good: 25,
    average: 28,
    poor: 32,
    industryAvg: 26
  },
  foodCost: {
    excellent: 28,
    good: 31,
    average: 34,
    poor: 38,
    industryAvg: 32
  }
};

export const QSR_KPI_DEFINITIONS = {
  splh: {
    name: 'Sales Per Labour Hour',
    shortName: 'SPLH',
    description: 'Total sales divided by total labour hours worked',
    formula: 'Total Sales / Total Labour Hours',
    unit: '$',
    importance: 'Critical metric for QSR profitability. Higher SPLH indicates better labour efficiency.',
    actionableInsights: [
      'Optimize staff scheduling during peak hours',
      'Cross-train employees for multiple positions',
      'Implement efficient order flow systems',
      'Reduce idle time with prep task assignments'
    ]
  },
  driveThrough: {
    name: 'Drive-Through Performance',
    metrics: {
      avgWaitTime: {
        name: 'Average Wait Time',
        description: 'Average time from order placement to food handoff',
        unit: 'minutes',
        target: 3.5
      },
      throughput: {
        name: 'Cars Per Hour',
        description: 'Number of vehicles served per hour during peak',
        unit: 'cars/hr',
        target: 80
      },
      accuracy: {
        name: 'Order Accuracy',
        description: 'Percentage of orders completed correctly',
        unit: '%',
        target: 98
      }
    }
  }
};

export const OPERATIONAL_IMPROVEMENTS = {
  splh: [
    {
      title: 'Peak Hour Staffing Optimization',
      description: 'Analyze historical data to align staff schedules with demand curves',
      impact: 'High',
      effort: 'Medium',
      expectedImprovement: '+$5-8 SPLH'
    },
    {
      title: 'Cross-Training Program',
      description: 'Train all staff on multiple stations to increase flexibility',
      impact: 'High',
      effort: 'High',
      expectedImprovement: '+$3-5 SPLH'
    },
    {
      title: 'Kitchen Display System Upgrade',
      description: 'Implement real-time order flow management',
      impact: 'Medium',
      effort: 'Low',
      expectedImprovement: '+$2-4 SPLH'
    }
  ],
  driveThrough: [
    {
      title: 'Dual-Lane Implementation',
      description: 'Add second order point for high-traffic periods',
      impact: 'High',
      effort: 'High',
      expectedImprovement: '-45 sec avg wait'
    },
    {
      title: 'Pre-staging System',
      description: 'Prepare common orders during predicted rush periods',
      impact: 'Medium',
      effort: 'Low',
      expectedImprovement: '-30 sec avg wait'
    },
    {
      title: 'Order Confirmation Display',
      description: 'Install customer-facing screens at order point',
      impact: 'Medium',
      effort: 'Medium',
      expectedImprovement: '+2% accuracy'
    }
  ],
  labour: [
    {
      title: 'Predictive Scheduling',
      description: 'Use AI to forecast demand and optimize rosters',
      impact: 'High',
      effort: 'Medium',
      expectedImprovement: '-2% labour cost'
    },
    {
      title: 'Break Optimization',
      description: 'Schedule breaks during natural lulls in traffic',
      impact: 'Low',
      effort: 'Low',
      expectedImprovement: '-0.5% labour cost'
    }
  ]
};

export const getLocationById = (id) => {
  return QSR_DEMO_LOCATIONS.find(loc => loc.id === id);
};

export const getLocationsByRegion = (region) => {
  return QSR_DEMO_LOCATIONS.filter(loc => loc.region === region);
};

export const getLocationsByType = (type) => {
  return QSR_DEMO_LOCATIONS.filter(loc => loc.type === type);
};

export const getDriveThruLocations = () => {
  return QSR_DEMO_LOCATIONS.filter(loc => loc.type === 'drive_through');
};

export const calculateAggregateMetrics = (locations = QSR_DEMO_LOCATIONS) => {
  const totalRevenue = locations.reduce((sum, loc) => sum + loc.metrics.dailyRevenue, 0);
  const avgSPLH = locations.reduce((sum, loc) => sum + loc.metrics.splh, 0) / locations.length;

  const driveThruLocations = locations.filter(loc => loc.metrics.driveThrough);
  const avgWaitTime = driveThruLocations.length > 0
    ? driveThruLocations.reduce((sum, loc) => sum + loc.metrics.driveThrough.avgWaitTime, 0) / driveThruLocations.length
    : 0;

  return {
    totalDailyRevenue: totalRevenue,
    totalWeeklyRevenue: locations.reduce((sum, loc) => sum + loc.metrics.weeklyRevenue, 0),
    totalMonthlyRevenue: locations.reduce((sum, loc) => sum + loc.metrics.monthlyRevenue, 0),
    avgSPLH: avgSPLH.toFixed(2),
    totalStaff: locations.reduce((sum, loc) => sum + loc.metrics.staff.onShift, 0),
    avgDriveThruWaitTime: avgWaitTime.toFixed(1),
    locationCount: locations.length,
    driveThruCount: driveThruLocations.length,
    topPerformer: locations.reduce((best, loc) =>
      loc.metrics.splh > best.metrics.splh ? loc : best
    )
  };
};

export const calculateLocationMetrics = (locationId) => {
  const location = getLocationById(locationId);
  if (!location) return null;

  const { metrics } = location;
  const splhStatus = metrics.splh >= QSR_BENCHMARKS.splh.good ? 'good'
    : metrics.splh >= QSR_BENCHMARKS.splh.average ? 'average' : 'poor';

  return {
    ...metrics,
    splhStatus,
    splhVsTarget: ((metrics.splh - metrics.splhTarget) / metrics.splhTarget * 100).toFixed(1),
    labourCostStatus: metrics.labourCostPercent <= QSR_BENCHMARKS.labourCost.good ? 'good'
      : metrics.labourCostPercent <= QSR_BENCHMARKS.labourCost.average ? 'average' : 'poor',
    foodCostStatus: metrics.foodCostPercent <= QSR_BENCHMARKS.foodCost.good ? 'good'
      : metrics.foodCostPercent <= QSR_BENCHMARKS.foodCost.average ? 'average' : 'poor',
  };
};
